import { UserCustomColors } from '../../types';
export const common_colors = [
    UserCustomColors.primary,
    UserCustomColors.warning,
    UserCustomColors.secondary,
    UserCustomColors.error,
    UserCustomColors.info,
];
